//import { Collapse } from 'bootstrap';
import recipeSlider from './hh-scripts/recipe-slider';
import Marquee from "./app/global-marquee";
import CountdownTimer from './app/global-countdown-timer';
import FeaturedCollectionSwiper from './hh-scripts/featured-collection';
import ReviewsSwiper from './hh-scripts/reviews-swiper';
import InitGiftNotes from './app/global-gift-note';
Marquee();
CountdownTimer();
FeaturedCollectionSwiper();
ReviewsSwiper();
InitGiftNotes({ selector: '[gift-note]'})
document.addEventListener('DOMContentLoaded', () => {
  recipeSlider();
});